import * as Animate from "react-reveal";
import TeamImg from "../../../assets/images/png/african-tech-team.webp";

const columns = [
  {
    heading: "Before Utiva",
    items: [
      "Multiple recruiters",
      "Long hiring cycles",
      "Several post-hire tools",
      "Fragmented payroll",
    ],
  },
  {
    heading: "With Utiva",
    items: [
      "One talent network",
      "One hiring flow",
      "One workforce infrastructure",
      "One payroll operation",
    ],
  },
];

const metrics = [
  { value: "42 → 7", label: "days to hire" },
  { value: "3–7 → 1", label: "operating systems" },
  { value: "$8K → $3K", label: "per hire" },
  { value: "5 days → 3 min", label: "payroll" },
];

const HireTransformationSection = () => {
  return (
    <section className="bg-[#0c0f49] py-16 md:py-20 lg:py-24 px-4">
      <div className="container mx-auto grid grid-cols-1 lg:grid-cols-hire-transformation items-center gap-10 lg:gap-14">
        <Animate.Fade bottom>
          <div className="relative rounded-3xl overflow-hidden min-h-[380px] md:min-h-[570px]">
            <img
              src={TeamImg}
              alt="Global technology team collaborating"
              className="w-full h-full object-cover absolute inset-0"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-transparent to-[#03043ee6]"></div>
            <span className="z-[1] text-secondary font-poppins text-sm font-extrabold tracking-widest uppercase absolute bottom-7 left-7">
              US Fintech · Global Team
            </span>
          </div>
        </Animate.Fade>

        <Animate.Fade bottom>
          <div>
            <p className="text-secondary font-poppins text-sm font-extrabold tracking-widest uppercase mb-6">
              Transformation story
            </p>
            <h2 className="text-3xl md:text-4xl lg:text-5xl leading-tight font-poppins font-black text-white tracking-[-0.03em] mb-8">
              From 42 Days to <span className="text-secondary">7.</span>
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-6">
              {columns.map((col) => (
                <div
                  key={col.heading}
                  className="bg-white/[0.06] border border-white/20 rounded-2xl p-5"
                >
                  <strong className="text-secondary font-poppins text-sm tracking-widest uppercase block mb-2.5">
                    {col.heading}
                  </strong>
                  <div className="grid gap-2">
                    {col.items.map((item) => (
                      <span
                        key={item}
                        className="text-indigo-100 font-poppins text-sm"
                      >
                        {item}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5">
              {metrics.map((metric) => (
                <span
                  key={metric.label}
                  className="border-l-[3px] border-secondary bg-white/10 grid gap-1 px-4 py-3.5"
                >
                  <b className="text-white font-poppins text-xl">
                    {metric.value}
                  </b>
                  <span className="text-indigo-100 font-poppins text-sm">
                    {metric.label}
                  </span>
                </span>
              ))}
            </div>
          </div>
        </Animate.Fade>
      </div>
    </section>
  );
};

export default HireTransformationSection;
